// icon:bx-arrow-back | Boxicons https://boxicons.com/ | Atisa
import * as React from "react";

function IconBxArrowBack(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      height="1em"
      width="1em"
      {...props}
    >
      <path d="M21 11H6.414l5.293-5.293-1.414-1.414L2.586 12l7.707 7.707 1.414-1.414L6.414 13H21z" />
    </svg>
  );
}

export default IconBxArrowBack;
